// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import styled from 'styled-components';

import BackgroundPage from 'common/components/BackgroundPage';
import { ButtonSection, ButtonSubmit } from 'common/modules/authentication/styles';

import Images from '../../themes/Images';

const Wrapper = styled.div`
  margin: 20px;
`;

const Message = styled.div`
  text-align: center;
`;

interface Props {
  signUpWith: string;

  t: any;
  history: any;
  location: any;
  match: any;
}

class AccessPage extends React.PureComponent<Props> {
  goToSignIn = () => {
    this.props.history.push('/login');
  }

  goToSignUp = () => {
    this.props.history.push(`/sign-up/with-${this.props.match.params.signUpWith}/${this.props.match.params.reference}`);
  }

  render() {
    const { t } = this.props;

    return (
      <BackgroundPage background={Images.background} title={t('signup')} logo={Images.logo}>
        <Wrapper>
          <Message>{t('alreadyHaveAnAccount')}</Message>
          <ButtonSection>
            <ButtonSubmit onClick={this.goToSignIn}>
              {t('signin')}<i className="material-icons" style={{ verticalAlign: 'middle' }}>chevron_right</i>
            </ButtonSubmit>
          </ButtonSection>
        </Wrapper>
        <Wrapper>
          <Message>{t('createYourAccount')}</Message>
          <ButtonSection>
            <ButtonSubmit onClick={this.goToSignUp}>
              {t('signup')}<i className="material-icons" style={{ verticalAlign: 'middle' }}>chevron_right</i>
            </ButtonSubmit>
          </ButtonSection>
        </Wrapper>
      </BackgroundPage>
    );
  }
}

export default translate('signup')(withRouter(AccessPage));



// WEBPACK FOOTER //
// ./src/advertisers/modules/signup/AccessPage.js